
<template>
  <div>
    <section>
      <div class="max-w-3xl m-auto">
        <div class="flex p-3">
          <div class="w-full">
            <h1 class="text-2xl font-semibold text-center">Account</h1>
            <h2 class="text-xl mt-12 text-center">Dashboards</h2>
            <router-link class="shadow-lg py-3 px-6 flex rounded max-w-md m-auto hover:shadow-xl mb-6 animated text-lg font-bold text-gray-700" v-for="(dashboard, index) in user.dashboards" :to="'/dash/'+dashboard" :key="index">
              {{dashboard}}
            </router-link>
            <!-- <h2 class="text-xl mt-12">Settings</h2>
            <p>Some user settings</p> -->

            <div v-if="!user.dashboards.length" class="my-4 text-center">
              <p class="text-gray-500 text-center">No Dashboards, add one now</p>
              <button class="bg-green-500 text-white rounded shadow-md py-2 px-5 animated hover:shadow cursor-pointer m-auto mt-3" @click="createDash">Create Dashboard</button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- User:
    <vue-json-pretty
      :data="user"
      >
    </vue-json-pretty> -->
  </div>
</template>


<script>


export default {
  name: 'Account',
  data: function(){
    return {
      view: {
        accountSettingsView: 'dashboards'
      },
      stripe: null
    }
  },
  computed: {
    user () {
      return this.$store.getters.userData
    }
  },
  mounted: function(){
    console.log('myaccount mounted');

    // we need to get the plan that the user is currently on
    // we need to get the dashboards the user currently has

    // init stripe
    // eslint-disable-next-line
    this.stripe = Stripe('pk_test_BUssONiFh3xhN5NAEw1lwbyB00dDqVcCsC');
  },
  methods: {
    createDash: function() {
      console.log('user wants to create a dashboard')
    },
    buySubscription: function(planName){

      let planKeys = {
        'enterprise': 'plan_FdndseM1hxUHQc',
        'business': 'plan_FdncTVWMQJZYTM',
        'starter': 'plan_FdncxYEOQUVhPI'
      }

      this.stripe.redirectToCheckout({
        items: [{plan: planKeys[planName], quantity: 1}],

        // Do not rely on the redirect to the successUrl for fulfilling
        // purchases, customers may not always reach the success_url after
        // a successful payment.
        // Instead use one of the strategies described in
        // https://stripe.com/docs/payments/checkout/fulfillment
        successUrl: 'http://localhost:8080/account?saleconfirmed=1&session_id={CHECKOUT_SESSION_ID}',
        cancelUrl: 'http://localhost:8080/account?canceled=1',
      })
      .then(result => {
        if (result.error) {
          // If `redirectToCheckout` fails due to a browser or network
          // error, display the localized error message to your customer.
          this.view.stripeError = result.error.message;
        }
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>
